import React, { useEffect } from 'react';
import './tabla.css';

function getClassString(classNumber) {
  switch (classNumber) {
    case 0:
    case 1:
    case 2:
      return 'sm.png';
    case 16:
    case 17:
    case 18:
      return 'bk.png';
    case 32:
    case 33:
    case 34:
      return 'me.png';
    case 48:
    case 50:
      return 'mg.png';
    case 64:
    case 66:
      return 'dl.png';
    default:
      return 'Desconocido';
  }
}

function drawFlag(canvasId, flagData) {
  var colors = {
    '0': 'rgba(0,0,0,0)',
    '1': 'rgb(0,0,0)',
    '2': 'rgb(128,128,128)',
    '3': 'rgb(255,255,255)',
    '4': 'rgb(254,0,0)',
    '5': 'rgb(255,127,0)',
    '6': 'rgb(255,255,0)',
    '7': 'rgb(128,255,0)',
    '8': 'rgb(0,255,1)',
    '9': 'rgb(0,254,129)',
    'A': 'rgb(0,255,255)',
    'B': 'rgb(0,128,255)',
    'C': 'rgb(0,0,254)',
    'D': 'rgb(127,0,255)',
    'E': 'rgb(255,0,252)',
    'F': 'rgb(255,0,128)'
  };

  var canvas = document.getElementById(canvasId);

  if (canvas.getContext) {
    var context = canvas.getContext('2d');
    var scale = canvas.width / 8;

    for (var i = 0; i < 64; i++) {
      var row = Math.floor(i / 8);
      var col = i % 8;
      var cell = flagData.charAt(i);

      var x = col * scale;
      var y = row * scale;

      context.fillStyle = colors[cell];
      context.fillRect(x, y, scale, scale);
    }
  }
}

function TablaSDLF({ jugadores }) {
  function convertGMarkToHex(gMark) {
    if (!gMark || typeof gMark !== 'string') return '';
    const hexString = gMark.startsWith('0x') ? gMark.slice(2) : gMark;
    return hexString;
  }

  useEffect(() => {
    const renderFlags = () => {
      jugadores.forEach((jugador) => {
        if (jugador.G_Name !== '--') {
          const canvasId = `flag-sdlf-${jugador.Orden}`;
          const canvas = document.getElementById(canvasId);
          const context = canvas.getContext('2d');

          // Limpiar el canvas
          context.clearRect(0, 0, canvas.width, canvas.height);

          // Dibujar los nuevos flags
          drawFlag(canvasId, convertGMarkToHex(jugador.G_Mark));
        }
      });
    };

    renderFlags();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        renderFlags();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [jugadores]);

  const maxOrden = Math.max(...jugadores.map(jugador => jugador.Orden), 0);
  const nuevoOrden = maxOrden + 1;

  // Función para formatear la fecha en DD-MM-AAAA HH:MM
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  return (
    <table className='table'>
      <thead>
        <tr>
          <th style={{ color: 'grey', textAlign: 'left', textTransform: 'uppercase' }}>#</th>
          <th style={{ color: 'grey', textAlign: 'left', textTransform: 'uppercase' }}>Personaje</th>
          <th style={{ color: 'grey', textAlign: 'left', textTransform: 'uppercase' }}>Clan</th>
          <th style={{ color: 'grey', textAlign: 'left', textTransform: 'uppercase' }}>Maxed desde</th>
        </tr>
      </thead>
      <tbody>
        {jugadores.map((jugador) => (
          <tr key={jugador.Orden}>
            <td data-label="#" style={{ color: 'white' }}>{jugador.Orden}</td>
            <td data-label="Personaje" style={{ color: 'white' }}>
              <div className={jugador.ConnectStat === 1 ? 'connected' : 'disconnected'}>
                <div className="player-container">
                  <img src={`assets/img/${getClassString(jugador.Class)}`} width="30" alt="" title={jugador.ConnectStat === 1 ? 'Conectado' : 'Desconectado'} style={{ marginRight: '8px' }} />
                  <span>{jugador.Name}</span>
                  {jugador.IsMaster === 1 && <img src="assets/img/star.gif" alt="Guild Master" style={{ width: '12px', height: '12px', border: 'none', marginLeft: '4px' }} />}
                </div>
              </div>
            </td>
            <td data-label="Clan" style={{ color: 'white' }}>
              {jugador.G_Name !== '--' && (
                <div className="clan-container">
                  <canvas className="canvas-clan" id={`flag-sdlf-${jugador.Orden}`} width="24" height="24" data-flag={convertGMarkToHex(jugador.G_Mark)} style={{ marginRight: '8px' }}></canvas>
                  <span>{jugador.G_Name}</span>
                </div>
              )}
            </td>
            <td data-label="Maxed desde" style={{ color: 'white' }}>{formatDate(jugador.Fecha)}</td>
          </tr>
        ))}
        <tr>
          <td style={{ color: 'white' }}>{nuevoOrden}</td>
          <td colSpan="3" style={{ textAlign: 'center', color: 'white' }}>¡¡PODRÍAS SER VOS!!</td>
        </tr>
      </tbody>
    </table>
  );
}

export default TablaSDLF;
